

document.addEventListener('DOMContentLoaded', function () {
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  var form = picker.closest('form');
  var variantIdInput = form ? form.querySelector('[data-variant-id]') : null;
  var priceEl = document.querySelector('[data-product-price]');
  var comparePriceEl = document.querySelector('[data-product-compare-price]');
  var discountEl = document.querySelector('[data-product-discount]');
  var addToCartBtn = document.querySelector('[data-add-to-cart-btn]');
  var addToCartText = document.querySelector('[data-add-to-cart-text]');
  var variantJsonEl = picker.querySelector('[data-variant-json]');

  var variants = [];
  try {
    variants = JSON.parse(variantJsonEl.textContent);
  } catch (err) {
    variants = [];
  }

  function getSelectedOptions() {
    var selected = [];
    var groups = picker.querySelectorAll('.custom-product-variant-option');
    groups.forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      selected.push(checked ? checked.value : null);
    });
    return selected;
  }

  function findMatchingVariant(selected) {
    return variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return opt === selected[i];
      });
    });
  }

  function updateSelectedStyles() {
    picker.querySelectorAll('.custom-product-variant-pill').forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-selected', input.checked);
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) priceEl.textContent = variant.priceFormatted;

    var onSale = variant.compareAtPrice > variant.price;
    if (comparePriceEl) {
      comparePriceEl.textContent = variant.compareAtPriceFormatted;
      comparePriceEl.hidden = !onSale;
    }
    if (discountEl) {
      if (onSale) {
        var pct = Math.round(((variant.compareAtPrice - variant.price) / variant.compareAtPrice) * 100);
        discountEl.textContent = pct + '% Off';
      }
      discountEl.hidden = !onSale;
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
    }
    if (addToCartText) {
      addToCartText.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  }

  picker.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') return;
    updateSelectedStyles();
    var selected = getSelectedOptions();
    var matched = findMatchingVariant(selected);
    updateUI(matched);
  });
});